<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary" tile>
      <v-toolbar-title>Summary</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="claim_data"
      :search="search"
      :sort-by="['AMOUNT']"
      :sort-desc="[true]"
      :footer-props="{
        'items-per-page-options': [25, 50, 75, 100, -1],
      }"
      :items-per-page="25"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      item-key="_id"
      loading-text="Loading data..."
      class="elevation-0 rounded-0"
    >
      <template v-slot:item.AMOUNT="{ item }">
        ${{ item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
      </template>

      <template v-slot:item.END_DATE="{ item }">
        {{ item.END_DATE !== null ? item.END_DATE : '-' }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td v-if="item.RX == null" :colspan="headers.length" class="px-0">
          <SpecCodes :insurance="insurance" :claimID="item._id" />
        </td>
        <td v-else :colspan="headers.length" class="pt-4">
          <v-alert type="info">No Codes</v-alert>
        </td>
      </template>
    </v-data-table>

    <v-card tile v-if="this.requestError === true && this.loading != true">
      <v-card-text>
        <v-row>
          <v-col>
            <v-alert type="error">Error getting high cost patients.</v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios';
import SpecCodes from './SpecCodes.vue';

export default {
  name: 'highCostPatientDetails',
  props: ['value', 'insurance', 'patientID', 'endDate', 'startDate', 'reportType'],
  components: {
    SpecCodes,
  },
  data() {
    return {
      uniqeId: '',
      search: '',
      singleExpand: true,
      expanded: [],
      dialog: false,
      loading: true,
      requestError: false,
      claim_data: [],
      headers: [
        { text: 'Claim Number', value: '_id' },
        { text: 'Servicer Name', value: 'SERVICER_NAME' },
        { text: 'Start Date', value: 'START_DATE' },
        { text: 'End Date', value: 'END_DATE' },
        { text: 'Amount', value: 'AMOUNT' },
      ],
    };
  },
  methods: {
    async getClaim() {
      this.loading = true;
      this.requestError = false;
      this.claim_data = [];
      let url = '';
      if (
        this.reportType === 'High Cost Patients' ||
        this.reportType === 'Chronic Conditions' ||
        this.reportType === 'Diagnostic Conditions'
      ) {
        url = `api/modal/highcost/patients/${this.insurance}/${this.patientID}/${this.startDate}/${this.endDate}`;
      } else {
        url = `api/modal/notseen/patients/${this.insurance}/${this.patientID}/${this.startDate}/${this.endDate}`;
      }
      axios
        .get(url)
        .then((response) => {
          this.claim_data = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.loading = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async patientID() {
      if (this.patientID != null && this.patientID != 0 && this.patientID != '') {
        this.getClaim();
      }
    },
  },
};
</script>
